import { EGameIntroductionType } from '@/types/request';
import { Status } from '@/utils';

export const FORM_NAME = {
  CREATE_GAME_INTRODUCTION: 'CREATE_GAME_INTRODUCTION',
  UPDATE_GAME_INTRODUCTION: 'UPDATE_GAME_INTRODUCTION',
} as const;

export const REDIRECT_TYPE_OPTIONS = [
  { label: 'のうKNOW', value: EGameIntroductionType.NOUNOW },
  { label: 'CogEvo', value: EGameIntroductionType.COGEVO },
] as const;

export const INITIAL_VALUES = {
  icon: null,
  iconAttachments: null,
  appName: '',
  cover: null,
  coverAttachments: null,
  title: '',
  type: EGameIntroductionType.NOUNOW as const,
  publicAt: null,
  publicEndAt: null,
  status: Status.PUBLIC,
};
